"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabWrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const TabWrapper = exports.TabWrapper = /*#__PURE__*/(0, _base.default)("button", process.env.NODE_ENV === "production" ? {
  target: "e1dmbbca0"
} : {
  target: "e1dmbbca0",
  label: "TabWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "44ia8h",
  styles: "display:flex;justify-content:center;align-items:center;flex-direction:column;flex:1;background-color:transparent;border:none"
} : {
  name: "44ia8h",
  styles: "display:flex;justify-content:center;align-items:center;flex-direction:column;flex:1;background-color:transparent;border:none",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});